export enum ActivityType {
  CUSTOM_CHALLENGE_ACTIVITY_TYPE_BICYCLE = "CUSTOM_CHALLENGE_ACTIVITY_TYPE_BICYCLE",
  COMPETITIVE_CHALLENGE_TYPE_BICYCLE = "COMPETITIVE_CHALLENGE_TYPE_BICYCLE",
  CUSTOM_CHALLENGE_ACTIVITY_TYPE_STANDARD = "CUSTOM_CHALLENGE_ACTIVITY_TYPE_STANDARD",
  COMPETITIVE_CHALLENGE_TYPE_STANDARD = "COMPETITIVE_CHALLENGE_TYPE_STANDARD",
  CUSTOM_CHALLENGE_ACTIVITY_TYPE_STEPS = "CUSTOM_CHALLENGE_ACTIVITY_TYPE_STEPS",
  COMPETITIVE_CHALLENGE_TYPE_STEPS = "COMPETITIVE_CHALLENGE_TYPE_STEPS",
}
